module.exports = __webpack_public_path__ + "img/zs-info.b47f06c0.png";